<script lang="ts">
  import { Icon, Button } from "@price-check/ui";
  import { Eye, Layers } from "lucide";
  import Pill from "../../lib/ui/Pill.svelte";
  import { loginLabel, loginTone } from "../../lib/snapshot-status";
  import { SNAPSHOT_KINDS, kindLabel, type SupplierSnapshots } from "../../lib/snapshot-groups";

  let {
    group,
    onView,
    onBrowse,
  }: {
    group: SupplierSnapshots;
    onView: (id: string) => void;
    onBrowse: (vendorId: string) => void;
  } = $props();

  function ago(iso: string): string {
    const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
    if (s < 60) return `${Math.floor(s)}s ago`;
    if (s < 3600) return `${Math.floor(s / 60)}m ago`;
    if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
    return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" });
  }
</script>

<li class="rounded-lg border border-border bg-surface p-3.5">
  <div class="flex flex-wrap items-baseline gap-x-2 gap-y-1">
    <span class="font-bold">{group.vendorName}</span>
    {#if group.vendorId !== group.vendorName}
      <span class="font-mono text-xs text-muted">{group.vendorId}</span>
    {/if}
    <span class="ml-auto">
      {#if group.missing.length === 0}
        <Pill tone="ok">complete</Pill>
      {:else}
        <Pill tone="amber">{group.missing.length} missing</Pill>
      {/if}
    </span>
  </div>
  <ul class="m-0 mt-2.5 flex list-none flex-col gap-1.5 p-0">
    {#each SNAPSHOT_KINDS as kind (kind)}
      {@const s = group.byKind[kind]}
      <li class="flex min-h-8 items-center gap-2">
        <span class="w-38 shrink-0 text-sm {s ? '' : 'text-muted'}">{kindLabel(kind)}</span>
        {#if s}
          <Pill tone={loginTone(s.login_state)}>{loginLabel(s.login_state)}</Pill>
          <span
            class="whitespace-nowrap text-xs text-muted"
            title={new Date(s.created_at).toLocaleString()}
          >
            {ago(s.created_at)}
          </span>
          <Button
            variant="outline"
            size="sm"
            class="ml-auto"
            aria-label="View {kindLabel(kind)} snapshot of {group.vendorName}"
            onclick={() => onView(s.id)}
          >
            <Icon icon={Eye} size={13} /> View
          </Button>
        {:else}
          <Pill tone="amber">Missing</Pill>
        {/if}
      </li>
    {/each}
  </ul>
  <Button
    variant="ghost"
    size="sm"
    class="mt-2 w-full justify-start px-0"
    aria-label="All captures for {group.vendorName}"
    onclick={() => onBrowse(group.vendorId)}
  >
    <Icon icon={Layers} size={13} /> All captures
  </Button>
</li>
